import { render, staticRenderFns } from "./ReportPageListItemFolder.vue?vue&type=template&id=1da5efac&scoped=true&"
import script from "./ReportPageListItemFolder.vue?vue&type=script&lang=ts&"
export * from "./ReportPageListItemFolder.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPageListItemFolder.vue?vue&type=style&index=0&id=1da5efac&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da5efac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
